import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import About from "@/pages/About";
import LegalPage from "@/pages/LegalPage";
import { privacyPolicy, returnsRefunds, termsConditions, warrantyPolicy } from "@/content/policies";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy-policy" element={<LegalPage {...privacyPolicy} />} />
      <Route path="/returns-refunds" element={<LegalPage {...returnsRefunds} />} />
      <Route path="/terms-and-conditions" element={<LegalPage {...termsConditions} />} />
      <Route path="/warranty-policy" element={<LegalPage {...warrantyPolicy} />} />
    </Routes>
  </BrowserRouter>
);

export default App;
